import { render, staticRenderFns } from "./ContractWiresTab.vue?vue&type=template&id=72ccc0f7&scoped=true"
import script from "./ContractWiresTab.vue?vue&type=script&lang=js"
export * from "./ContractWiresTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ccc0f7",
  null
  
)

export default component.exports